import { render } from "./AuthPhoneComplete.vue?vue&type=template&id=12750575&ts=true"
import script from "./AuthPhoneComplete.vue?vue&type=script&lang=ts"
export * from "./AuthPhoneComplete.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3623750061/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__